import * as assetLinkActions from './actions';
import * as api from '../../api';
import { message } from '@myua/kit';
import { takeEvery } from '../../listenerMiddleware';

export const assetLinkListeners = () => {
  watchDeleteConfirmed();
  watchEditSubmitted();
};

function watchDeleteConfirmed() {
  takeEvery(assetLinkActions.deleteConfirmed, async (action, { dispatch }) => {
    dispatch(assetLinkActions.setInProgress({ inProgress: true }));
    const result = await api.deleteAssetLink(action.payload.linkId);
    dispatch(assetLinkActions.setInProgress({ inProgress: false }));

    if (result.success) {
      void message.success('The link has been deleted');
      dispatch(
        assetLinkActions.deleted({
          assetId: action.payload.assetId,
          linkId: action.payload.linkId,
        }),
      );
    } else {
      void message.error('The link has not been deleted');
    }
  });
}

function watchEditSubmitted() {
  takeEvery(assetLinkActions.editSubmitted, async (action, { dispatch }) => {
    dispatch(assetLinkActions.setInProgress({ inProgress: true }));
    let result;
    if (action.payload.linkId) {
      result = await api.updateAssetLink(action.payload.linkId, action.payload.url);
    } else {
      result = await api.createAssetLink(action.payload.assetId, action.payload.url);
    }
    dispatch(assetLinkActions.setInProgress({ inProgress: false }));

    if (result.success) {
      void message.success('The link has been saved');
      dispatch(assetLinkActions.saved({ link: result.data.response }));
    } else {
      void message.error('The link has not been saved');
    }
  });
}
